export const fileType = {
    PDF: { extension: '.pdf', mimeType: 'application/pdf' },
    IMAGE: ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/webp'],
    VIDEO: ['.mp4', '.mov'],
    SCORM: '.zip',
  };
  